<template>
  <div id="emergency-plan1">
    <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>
    <div class="wrapper">
      <div class="section section1">
        <span class="title">应急保障</span>
        <span class="tip"> — 方案咨询</span>
      </div>
      <div class="section section2">
        <div class="input-box">
          <span>联系人</span>
          <input placeholder="输入联系人姓名" maxlength="10" v-model="planInfo.user_name" v-on:focus="focus()" @blur="blur(0)" />
        </div>
        <div class="input-box">
          <span>手机号</span>
          <input placeholder="输入联系人手机号" maxlength="11" v-model="planInfo.phone" oninput="value=value.replace(/[^\d]/g,'')" v-on:focus="focus()" @blur="blur(1)" />
        </div>
        <div class="input-box" v-on:click="addressClick">
          <span>项目地址</span>
          <input placeholder="请选择" v-model="address" readonly="readonly" unselectable="on" />
          <div></div>
        </div>
        <div class="input-box textarea-box">
          <span>详细地址</span>
          <textarea placeholder="输入项目详细地址如道路、门牌号、小区、楼栋号、单元室等" maxlength="50" v-model="planInfo.address_detail" v-on:focus="focus()" @blur="blur(0)"></textarea>
        </div>
      </div>
    </div>
    <bottomButton id="bottomButton" title="下一步" :state="bottomState"  @click="bottomClick"></bottomButton>
    <!--  地址选择  -->
    <AreaView :show="addressVisible" @selectedArea="selectedArea"></AreaView>
  </div>
</template>

<script>
// import wxShare from '../wx/weixin.js'
import { Toast } from 'mint-ui'
import AreaView from '../components/area-view'
import mainHeader from '../view/header'
import bottomButton from '../components/bottom-button'

export default{
  inject: ['reload'], // 界面刷新
  data () {
    return {
      addressVisible: false,
      bottomState: 0,
      address: '',
      planInfo: {
        user_name: '',
        phone: '',
        region_id: 0,
        province: '',
        city: '',
        area: '',
        address_detail: ''
      }
    }
  },
  methods: {
    logoutClick: function () { // 退出登录
      this.$router.push({path: 'home'})
    },
    blur: function (index) {
      if (this.utils.isIphone()) { // iphone 适配键盘 弹出 回弹
        const currentScrollY = window.scrollY
        window.scrollTo(0, currentScrollY)
      } else {
        document.getElementById('bottomButton').style.display = 'block'
      }
      if (index === 1) {
        if (!this.utils.isPhone(this.planInfo.phone)) {
          Toast('请输入正确的手机号')
        }
      }
    },
    focus: function () {
      if (!this.utils.isIphone()) {
        document.getElementById('bottomButton').style.display = 'none'
      }
    },
    addressClick: function () {
      this.addressVisible = true
    },
    selectedArea: function (province, city, area, code) {
      this.addressVisible = false
      this.planInfo.province = province
      this.planInfo.city = city
      this.planInfo.area = area
      this.planInfo.region_id = code

      this.address = province + ' ' + city + ' ' + area

      console.log(this.address)
    },
    checkParam: function () {
      if (this.utils.isNull(this.planInfo.user_name)) {
        Toast('请输入联系人姓名')
        return false
      }
      if (this.utils.isNull(this.planInfo.phone)) {
        Toast('请输入联系方式')
        return false
      }
      if (!this.utils.isPhone(this.planInfo.phone)) {
        Toast('请正确输入联系方式')
        return false
      }
      if (this.utils.isNull(this.planInfo.province)) {
        Toast('请选择项目地址')
        return false
      }
      if (this.utils.isNull(this.planInfo.address_detail)) {
        Toast('请输入详细地址')
        return false
      }
      return true
    },
    bottomClick: function () {
      if (this.checkParam() === false) {
        return
      }
      localStorage.setItem('planInfo', this.QS.stringify(this.planInfo))
      this.$router.push({path: 'emergency-plan2'})
    },
    loadData: function () {
      let info = this.QS.parse(localStorage.getItem('planInfo'))
      console.log(this.QS.stringify(info))
      if (this.utils.isNull(this.QS.stringify(info))) {
        return
      }
      this.planInfo = info
      this.address = info.province + ' ' + info.city + ' ' + info.area
      console.log(this.planInfo)
    }
  },
  components: {
    mainHeader,
    bottomButton,
    AreaView
  },
  watch: {
    isActive: function (val) {
      if (val === true) {
        this.bottomState = 1
      } else {
        this.bottomState = 0
      }
    }
  },
  computed: { // 计算
    isActive: function () {
      if (this.planInfo.user_name.length > 0 && this.planInfo.phone.length > 0 &&
        this.planInfo.province.length > 0 && this.planInfo.address_detail.length > 0) {
        return true
      }
      return false
    }
  },
  mounted () {
    document.body.scrollTop = document.documentElement.scrollTop = 0
    // 微信 分享
    // wxShare.wxRegister('在线提问，为你解忧', '写出您的消防问题，数百位行业专家在线答疑', 'http://cdn.zxzx119.com/4689248674381824')
    // 登录状态
    var _this = this
    this.utils.isUserLogin(function (login) {
      console.log('==========' + login)
      if (login === 0) {
        Toast('您还未登录，请登录后再咨询！')
        _this.$router.push({path: 'login', query: {back: 1}})
      } else {
        _this.loadData()
      }
    })
  }
}

</script>

<style scoped>
  .mainHeader{
    position: fixed;
    top: 0px;
    height: 55px;
    width: 100%;
    z-index: 500;
  }
  .wrapper{
    position: absolute;
    height: 100%;
    width: 100%;
    margin-top: 55px;
    background-color: #F1F1F1;
  }
  .section{
    position: relative;
    width: 100%;
    background-color: #FFFFFF;
  }
  .section1{
    height: 60px;
    box-sizing: border-box;
    border-bottom: #F1F1F1 solid 10px;
  }
  .section1 .title{
    height: 50px;
    line-height: 50px;
    color: #000;
    font-size: 16px;
    font-weight: bold;
    margin-left: 15px;
  }
  .section1 .tip{
    height: 50px;
    line-height: 50px;
    color: #000;
    font-size: 13px;
    font-weight: bold;
    margin-left: 5px;
  }
  .section2{
    height: 270px;
    background-color: #FFFFFF;
  }
  .section2 .input-box{
    position: relative;
    width: 100%;
    height: 55px;
    line-height: 55px;
    box-sizing: border-box;
    border-bottom: #eeeeee solid 1px;
  }
  .section2 .textarea-box{
    height: 105px;
  }
  .section2 .input-box span{
    padding-left: 15px;
    width: 100px;
    font-size:15px;
    color: #323232;
    /*height: ;*/
  }
  .section2 .input-box input{
    position: absolute;
    top: 10px;
    left: 90px;
    width: calc(100% - 115px);
    height: 35px;
    line-height: 35px;
    font-size:15px;
    color: #000000;
    box-sizing: border-box;
    border: none;
    /*background-color: antiquewhite;*/
  }
  .section2 .input-box textarea{
    position: absolute;
    top: 15px;
    left: 90px;
    width: calc(100% - 115px);
    height: 75px;
    line-height: 25px;
    font-size:15px;
    color: #000000;
    box-sizing: border-box;
    border: none;
  }
  .section2 .input-box div{
    position: absolute;
    left: calc(100% - 20px);
    top: 22px;
    width: 6px;
    height: 10px;
    background-image: url(../assets/next.png);
    background-size: cover;
    background-position: center center;
  }
</style>



// WEBPACK FOOTER //
// src/view/emergency-plan-info1.vue